export const GET_ACTIVE_ATTRIBUTES_STARTED = 'GET_ACTIVE_ATTRIBUTES_STARTED'
export const GET_ACTIVE_ATTRIBUTES_SUCCESS = 'GET_ACTIVE_ATTRIBUTES_SUCCESS'
export const GET_ACTIVE_ATTRIBUTES_FAILURE = 'GET_ACTIVE_ATTRIBUTES_FAILURE'
